import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type {
  HotelDiscover,
  HotelDiscoverForm,
} from 'app/typings/hotels/Hotel/HotelDiscover';
import { apiMutation, apiRequest } from 'app/utils/request/api';

const hotelDiscoversPath = 'hotels/:hotelId/discover' as const;

export function useGetHotelDiscover({
  hotelId,
  forceDisable,
}: {
  hotelId?: number;
  forceDisable?: boolean;
}) {
  return useQuery<HotelDiscover>({
    queryKey: [hotelDiscoversPath, { hotelId }],
    queryFn: !!hotelId
      ? () =>
          apiRequest({
            path: hotelDiscoversPath,
            params: { hotelId: hotelId?.toString() },
          }).catch((err) => message.error('Error fetching discover', err))
      : undefined,
    enabled: !!hotelId && !forceDisable,
    refetchOnWindowFocus: false,
  });
}

export function useSaveHotelDiscover({ hotelId }: { hotelId: number }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: HotelDiscoverForm) =>
      apiMutation(
        'POST',
        {
          path: hotelDiscoversPath,
          params: { hotelId: hotelId.toString() },
        },
        payload
      ) as Promise<void>,
    onSuccess: () => {
      message.success('Discover successfully saved!');
      queryClient.invalidateQueries({
        queryKey: [hotelDiscoversPath, { hotelId }],
      });
    },
    onError: () => {
      message.error('Error saving discover');
    },
  });
}
